import { getCurrencies } from 'api/node/currencies';
import { SelectField } from 'components/Fields';
import { useMemo } from 'react';
import { useAsync } from 'react-async';
import { formatCurrencyLabel } from 'utils';

const SelectCurrencyField = ({ ...props }) => {
  const { data: currenciesData } = useAsync({ promiseFn: getCurrencies });

  const data = currenciesData?.data;
  const currenciesOptions = useMemo(
    () =>
      (data ?? []).map(({ name: currency }) => ({
        value: currency,
        label: formatCurrencyLabel(currency),
      })),
    [data],
  );

  return (
    <SelectField
      options={currenciesOptions}
      {...props}
      renderSelectedValue={(value) =>
        value?.label || formatCurrencyLabel(value)
      }
    />
  );
};

export default SelectCurrencyField;
